var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.96 44.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39637b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_5",
    "data-name": "Warstwa 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.13,45a19.23,19.23,0,0,1-6.61-1.41c-5.45-2-11.37-6.11-16.69-11.42S3.46,20.88,1.4,15.44c-1.86-5-1.87-9,0-10.88l.82-.85C3.91,1.92,5.83-.09,8.37,0c1.76.08,3.46,1.16,5.19,3.33,5.14,6.39,2.83,8.67.14,11.31l-.47.46c-.44.44-1.27,2.47,6.44,10.18a43.42,43.42,0,0,0,6.38,5.48c1.08.7,3,1.76,3.8,1l.48-.48c2.64-2.68,4.91-5,11.3.14,2.16,1.74,3.25,3.44,3.32,5.2.11,2.54-1.92,4.46-3.7,6.16-.3.28-.59.55-.85.82A6,6,0,0,1,36.13,45ZM8.19,1.51c-1.8,0-3.44,1.72-4.88,3.24l-.85.88c-1.38,1.38-1.24,5,.36,9.27,2,5.25,5.92,11,11.08,16.16s10.9,9.1,16.15,11.08c4.25,1.6,7.89,1.74,9.28.36.27-.28.57-.56.88-.85,1.55-1.48,3.31-3.15,3.23-5,0-1.27-1-2.64-2.76-4.07-5.32-4.28-6.8-2.77-9.27-.27l-.49.49c-1.18,1.18-3.09.92-5.69-.77a43.22,43.22,0,0,1-6.62-5.67C12.21,20,10.16,16,12.16,14l.49-.48c2.5-2.46,4-4-.26-9.28C11,2.5,9.59,1.57,8.31,1.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIco);
export default __webpack_public_path__ + "static/media/phone-ico.66b34eab558958434bf9570889602da9.svg";
export { ForwardRef as ReactComponent };